<template>
  <div class="li_bg">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
      <div class="row">
        <div class="col-md-6 offset-md-6">
          <div class="login_box p-4">
            <!-- <img class="img-fluid" src="@/assets/img/dual_energy_logo.png"> -->
            <h2 class="my-3">{{totd}}</h2>
            <div class="text-center">
              <p>{{qotd}}</p>
              <input type="submit" class="btn btn-outline-dark bg-warning btn-lg w-50 mt-4" value="Log In" @click="login">
            </div>
          </div>
        </div>
      </div>
    </div>
        <div class="col-md-12 no-pad">
          <div class="bg_imgs">
          <agile fade autoplay :autoplaySpeed="9000" :speed="3000" timing="ease-in-out" :dots="false" :arrows="false" :pauseOnHover="false">
            <div class="slide slide--1">
              <img class="top w-100" src="@/assets/img/login_page/bg_light.jpg" alt="Vintage Light">
            </div>
            <div class="slide slide--2">
              <img class="bottom w-100" src="@/assets/img/login_page/bg_antwerp.jpg" alt="Antwerp street and nuclear plant">
            </div>
            <div class="slide slide--3">
              <img class="top w-100" src="@/assets/img/login_page/bg_dam.jpg" alt="Dam on a dark day">
            </div>
          </agile>
        </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    props: ['authStyle'],
    computed: {
      totd() {
      var hr = new Date().getHours(); 
      if (hr >= 0 && hr <= 11) {
        return "Good Morning!"
      } else if (hr >= 12 && hr <= 17) {
        return "Good Afternoon!"
      } else {
        return "Good Evening!"
      }
      },
      qotd() {
      var hr = new Date().getHours();
      if (hr >= 0 && hr <= 11) {
        return "Some days you just have to create your own sunshine. - Sam Sundquist"
      } else if (hr >= 12 && hr <= 17) {
        return "Good, better, best. Never let it rest. 'Til your good is better and your better is best. - St Jerome"
      } else {
        return "How did it get so late so soon? It's night before it's afternoon. - Dr Seuss"
      }
      },
      styles() {
     // returns an array of registered authStyles
     return this.$auth.styles;
   }
 },
 methods: {
   login() {
     // requests an accessToken according to the authStyle that is passed in. Will redirect in most cases.
     this.$auth.login(this.authStyle)
   }
 }
}
</script>


